export default __webpack_public_path__ + "static/Witcher-67bf3e58fdacff8021d696de85f3c457.png";